import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Fragment, useEffect } from 'react';

import { AuthRedirect } from '@/components/ui/features/authRedirect/AuthRedirect';
import { LogInFormSection } from '@/components/ui/features/log-in/LogInFormSection/LogInFormSection';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { useAnalytics } from '@/context/Analytics';
import { AccessFrom } from '@/enums/AccessFrom';
import { useQueryParams } from '@/hooks/useQueryParams';
import { StringParam } from '@/utils/url-query-string';

interface IQueryParams {
  redirectUrl: string;
  accessFrom: AccessFrom;
  stay: boolean;
}

const LogIn: NextPage = () => {
  const { redirectUrl, accessFrom, stay } = useQueryParams<IQueryParams>({
    redirectUrl: StringParam,
    accessFrom: StringParam,
    stay: StringParam,
  });

  const analytics = useAnalytics();

  useEffect(() => {
    analytics.track('user_login_open');
  }, [analytics]);

  return (
    <Fragment>
      <NextSeo
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}log-in`}
        title="Log in"
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/log-in`,
        }}
      />
      <AuthRedirect redirectTo={redirectUrl} ifFound={!stay} />
      <Layout accessFrom={accessFrom} navigationVariant="inverted" displayFooter={false}>
        <LogInFormSection />
      </Layout>
    </Fragment>
  );
};

// keep this pages SSR because we need a query params on initial render
export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};

export default LogIn;
